import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import BackToTop from '../components/backToTop/BackToTop';
import RenewalQuoteDetail from '../components/quote/RenewalQuoteDetail';
import '../components/quote/quote.scss';
import { addInterestToPrice } from '../functions/Renewal';
import { GetLogo } from '../components/quote/Logos';
import './payment.scss';

export default function YourRenewal(props: any) {
    const navigate = useNavigate();
    const location = useLocation();
    const [renewal, setRenewal] = useState<any>(null);
    const [payAnnual, setPayAnnual] = useState<boolean>(false);
    const [showDetails, setShowDetails] = useState<boolean>(false);
    const paymentError = location.state?.paymentError;

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    let pageNo: number = 5;
    const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData') as string) : null;
    const config = JSON.parse(localStorage.getItem('siteConfig') || "{}");

    useEffect(() => {
        props.setCurrentPage(pageNo);
        const renewalData = localStorage.getItem('renewal') ? JSON.parse(localStorage.getItem('renewal') as string) : null;
        if (renewalData.paymentPlans.length === 0 || renewalData.paymentPlans[0].id === "652320AF256942149924DAE952A6C1C4") {
            setPayAnnual(true);
        }
        setRenewal(renewalData);

        fetch(`${apiBaseUrl}customer/GetCustomerByInsuredPartyID?insuredPartyId=${renewalData.insuredPartyId}`, {
            headers: {
                'Accept': 'application/json, text/plain',
                'Content-Type': 'application/json;charset=UTF-8'
            },
        })
            .then(response => {
                return response.json();
            }).then(data => {
                let customerDetails = data;
                customerDetails.email = userData.email;
                localStorage.setItem("customerDetails", JSON.stringify(customerDetails));
            })
            .catch((error) => {
            });

    }, [])

    const buyCover = () => {

        if (payAnnual) {
            localStorage.setItem("policyRef", renewal.policyNumber);
            fetch(`${apiBaseUrl}admin/PurchaseRenewal`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain',
                    'Content-Type': 'application/json;charset=UTF-8'
                },
                body: JSON.stringify({
                    policyNumber: renewal.policyNumber,
                    policyHistoryId: renewal.historyId.toString(),
                    annual: payAnnual,
                    "bankDetails": {
                        "accountNo": "",
                        "holder": "",
                        "bankName": "",
                        "sortCode": "",
                        "sortCode1": "",
                        "sortCode2": "",
                        "sortCode3": ""
                    },
                    token: userData.token,
                    clientURL: window.location.origin
                })
            })
                .then(response => {
                    return response.json();
                }).then(data => {
                    window.location.href = data.object;
                })
                .catch((error) => {
                });
        } else {
            navigate("/RenewalPayment");
        }
    }

    return (
        <>
            <div className="form-container">
                {paymentError &&
                    <div className="payment-failed">
                        {paymentError}
                    </div>
                }
                <div className="form-title">
                    <h1>Your renewal</h1>
                </div>

                {payAnnual && <p className="renewal-contact">To pay by instalments please contact us on {config.phoneNumber}</p>}
                {!payAnnual && <p className="renewal-contact">To pay in full please contact us on {config.phoneNumber}</p>}

                {renewal != null &&
                    <div className="quote-container renewal">
                    <table className="quote-details">
                        <tbody>
                            <tr>
                                    <td rowSpan={2} className="insurer-details">
                                        {GetLogo(renewal.schemeName, renewal.insurerId, renewal.insurer, false)}
                                        <span className="insurer-name">{renewal.insurer}</span></td>
                                <>
                                    <td><div className="total-amount">
                                            {payAnnual &&
                                                <div>&pound;{parseFloat(renewal.premiumInCapr.toString()).toFixed(2)}
                                            </div>
                                        }
                                        {!payAnnual &&
                                                <span>&pound;{parseFloat(renewal.premiumInCapr.toString()).toFixed(2)}</span>
                                        }
                                    </div>
                                    </td>
                                    <td><div className="monthly-breakdown">
                                            {!payAnnual &&
                                                <span>1 x &pound;{addInterestToPrice(renewal.paymentPlans[0].instalments[0].capital, renewal.paymentPlans[0].instalments[0].interest)}</span>
                                        }
                                    </div>
                                    </td>
                                </>



                                <td><button className="buy-btn renewal" onClick={() => buyCover()}>{payAnnual ? "Pay in full" : "Pay monthly"}</button></td>
                            </tr>
                            <tr className="quote-sub">
                                <td><div>Total</div></td>


                                <td>
                                    {!payAnnual &&
                                            <div>{renewal.paymentPlans[0].noInstalments - 1} x &pound;{addInterestToPrice(renewal.paymentPlans[0].instalments[1].capital, renewal.paymentPlans[0].instalments[1].interest)}</div>
                                    }
                                </td>
                                    {!showDetails &&
                                        <td><span className="details" onClick={() => setShowDetails(true)}>Details</span></td>
                                    }

                                    {showDetails &&
                                        <td><span className="details" onClick={() => setShowDetails(false)}>Hide details</span></td>
                                    }
                            </tr>
                        </tbody>
                        </table>
                        <br />
                        {showDetails &&
                            <RenewalQuoteDetail quote={renewal} payAnnual={payAnnual} policyNumber={renewal.policyNumber} />
                        }

                        <div className="underwritten">Underwritten by {renewal.insurer}. includes IPT and any administration charge which is detailed within your invite pack for this policy.</div>
                </div>
                }

            </div>

        </>
    )
}